import ImageIconSolid from '@/components/icons/ImageIconSolid';
import { FC, Fragment } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

type Props = {};

const NewsAndOffersCardSkeleton: FC<Props> = () => {
	return (
		<div className='flex flex-col flex-1 border border-popover-100 rounded-2.5xl bg-popover-10 overflow-hidden'>
			<Skeleton className='h-50 rounded-none flex items-center justify-center bg-popover-100'>
				<ImageIconSolid className='size-16 fill-popover-400' />
			</Skeleton>
			<div className='p-6 flex flex-col gap-4'>
				<Skeleton className='h-3 w-16 my-1 rounded-full' />
				<div className='flex flex-col gap-2'>
					<Skeleton className='h-3 w-36 my-2 rounded-full' />
					<div>
						<Skeleton className='h-3 w-full my-1.5 rounded-full' />
						<Skeleton className='h-3 w-full my-1.5 rounded-full' />
						<Skeleton className='h-3 w-full my-1.5 rounded-full' />
					</div>
				</div>
				<Skeleton className='h-3 w-16 my-1 rounded-full' />
			</div>
			<div className='p-6 flex justify-center gap-4 border-t border-popover-100'>
				<Skeleton className='h-11 w-full rounded-full' />
				<Skeleton className='h-11 w-full rounded-full' />
			</div>
		</div>
	);
};

export default NewsAndOffersCardSkeleton;
